import { useLocation, useNavigate } from "react-router-dom";

import { type PaymentType as PayableType } from "@/api-v3";
import { startClaimDetour } from "@/features/payment-methods";
import { useAppDispatch } from "@/store";
import { AppRoute } from "@/types/routes";

/**
 * Starts the Claim Detour from the current route, so the payment methods list
 * knows what kind to offer and where to come back to. The Claim draft survives
 * because `useClaimDraftCleanup` exempts a live detour.
 */
export const useClaimDetour = (requiredPayableType: PayableType) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  return () => {
    dispatch(startClaimDetour({ returnTo: pathname, requiredPayableType }));
    navigate(AppRoute.PAYMENT_METHODS_LIST);
  };
};
